module.exports = __webpack_public_path__ + "static/media/Entreprise-Direction-de-Travaux-Vaud.c559a5fd.jpg";